const LOCALIZED_ROUTES = {
  '/connexion': 'connexion',
  '/compte': 'compte',
  '/': 'index',
}

export function localizedAuthRedirect(to, localePath) {
  const name = LOCALIZED_ROUTES[to]

  return name ? localePath({ name }) : to
}
